import { create } from 'zustand'

type Store = {
	theme: string
}

type Action = {
	switchTheme: (theme: Store['theme']) => void
}

export const useThemeStore = create<Store & Action>()((set) => ({
	theme: 'light',
	switchTheme: (theme) => {
		document.documentElement.classList.remove('dark')
		localStorage.setItem('theme', theme)
		set(() => ({ theme: 'light' }))
	}
}))
